// extracted by mini-css-extract-plugin
module.exports = {"elt":"style_elt__19GM7","customButon":"style_customButon__3MJrR"};